import { enGB, sv } from 'date-fns/locale'
import type { Locale as DateFnsLocale } from 'date-fns'
import type { Locale } from '@hub/contracts'
import { useLocale } from './locale'

/** date-fns locale for `format` / `formatDistanceToNow`. */
export function dateFnsLocale(locale: Locale): DateFnsLocale {
  return locale === 'en' ? enGB : sv
}

/** BCP 47 tag for `Intl` / `toLocale*String` (en-GB: 24h clock, day-first dates). */
export function intlLocale(locale: Locale): string {
  return locale === 'en' ? 'en-GB' : 'sv-SE'
}

/** Both flavours of the active locale, for components that format dates. */
export function useDateLocale(): { locale: Locale; dateFns: DateFnsLocale; intl: string } {
  const { locale } = useLocale()
  return { locale, dateFns: dateFnsLocale(locale), intl: intlLocale(locale) }
}
